import React from 'react'
import '../styles/css/ContentSidebar.css'

const ContentSidebar = ({ children, title, toggle }) => (
    <div className="content-sidebar-container" tabIndex="0">
        <div className="content-sidebar">
            <div className="content-sidebar-inner">
                <div className="content-sidebar-header">
                    <h1>{title}</h1>
                    <button onClick={toggle}>&times;</button>
                </div>
                {children}
            </div>
        </div>
    </div>
)

export default ContentSidebar


// WEBPACK FOOTER //
// ./src/components/ContentSidebar.js